var allInterestsData = [];
var hasInterests = false;
var newUrl = window.location.origin + window.location.pathname;
var parsedUrl = $.url.parse(document.URL);

$(function () {
    $('.select2').select2();

    allInterestsData = $('#interestFilter option').map(function () {
        var option = $(this);

        return {
            id: option.val(),
            text: option.text()
        };
    })
    .get();

    initEvents();
    updateOpportunities();
    initFilters(parsedUrl);
});

function initFilters(parsedUrl) {
    if (parsedUrl.params) {

        if (parsedUrl.params.interestIds != null) {
            var selectedInterestIds = parsedUrl.params.interestIds.split(',');

            if (selectedInterestIds != null) {
                hasInterests = true;
            }
            $('#interestFilter').val(selectedInterestIds).trigger('change');
        }

        if (parsedUrl.params.interestCategoryIds != null) {
            var selectedInterestCategoryIds = parsedUrl.params.interestCategoryIds.split(',');
            $('#interestCategoryFilter').val(selectedInterestCategoryIds).trigger('change');
        }

        if (parsedUrl.params.specialSkillIds != null) {
            var selectedSpecialSkillIds = parsedUrl.params.specialSkillIds.split(',');
            $('#specialSkillFilter').val(selectedSpecialSkillIds).trigger('change');
        }

        if (parsedUrl.params.placeIds != null) {
            var selectedPlaceIds = parsedUrl.params.placeIds.split(',');
            $('#placeFilter').val(selectedPlaceIds).trigger('change');
        }
    }
}

function initEvents() {
    $(document).on('change', '#specialSkillFilter', updateOpportunities);
    $(document).on('change', '#interestFilter', updateOpportunities);
    $(document).on('change', '#placeFilter', updateOpportunities);
    $(document).on('change', '#interestCategoryFilter', function () {
        var categoryIds = getCommaSepString('#interestCategoryFilter');

        if (categoryIds) {
            $.getJSON('/api/GetInterestsByCategory?interestCategories=' + categoryIds, function (result) {
                $('#interestFilter').select2('destroy')
                    .empty()
                    .select2({
                        data: allInterestsData.filter(function (x) {
                            return result.interestIds.indexOf(x.id) >= 0;
                        })
                    });

                if (hasInterests) {
                    var selectedInterestIds = parsedUrl.params.interestIds.split(',');
                    $('#interestFilter').val(selectedInterestIds).trigger('change');
                    hasInterests = false;
                }

                updateOpportunities();
            });
        }
        else {
            $('#interestFilter').select2('destroy')
                .empty()
                .select2({
                    data: allInterestsData
                });

            if (hasInterests) {
                var selectedInterestIds = parsedUrl.params.interestIds.split(',');
                $('#interestFilter').val(selectedInterestIds).trigger('change');
                hasInterests = false;
            }

            updateOpportunities();
        }
    });

    $(document).on('click', '#clearFiltersBtn', function () {
        $('#placeFilter').val('').trigger('change');
        $('#interestFilter').val('').trigger('change');
        $('#interestCategoryFilter').val('').trigger('change');
        $('#specialSkillFilter').val('').trigger('change');
        updateOpportunities();

        newUrl = window.location.origin + window.location.pathname;
        history.replaceState({ path: newUrl }, '', newUrl);
    });

    $(document).on('click', '#filterToMyInterestsBtn', function () {
        $('#interestCategoryFilter').val('').trigger('change');
        $('#interestFilter').val('').trigger('change');
        $('#specialSkillFilter').val('').trigger('change');

        var myInterestIds = $(this).data('myInterestIds').split(',');

        $('#interestFilter').val(myInterestIds).trigger('change');
        updateOpportunities();
    });

    $(document).on('click', '#filterToMySkillsBtn', function () {
        $('#interestCategoryFilter').val('').trigger('change');
        $('#interestFilter').val('').trigger('change');
        $('#specialSkillFilter').val('').trigger('change');

        var mySpecialSkillIds = $(this).data('mySpecialSkillIds').split(',');

        $('#specialSkillFilter').val(mySpecialSkillIds).trigger('change');
        updateOpportunities();
    });
}

function updateOpportunities() {
    $('.volunteerGroupDiv').show();
    $('.departmentDiv').show();

    var placeIds = $('#placeFilter')
        .select2('data')
        .map(function (x) {
            return x.id;
        });

    var interestIds = $('#interestFilter')
        .select2('data')
        .map(function (x) {
            return x.id;
        });

    var interestCategoryIds = $('#interestCategoryFilter')
        .select2('data')
        .map(function (x) {
            return x.id;
        });

    var specialSkillIds = $('#specialSkillFilter')
        .select2('data')
        .map(function (x) {
            return x.id;
        });

    if (placeIds.length > 0 || interestIds.length > 0 || interestCategoryIds.length > 0 || specialSkillIds.length > 0) {
        $('.volunteerGroupDiv').each(function (i, e) {
            var doShow = true;

            if (interestIds.length > 0 && !$(this).data('interestIds').split(',').some(function (x) { return interestIds.includes(x); })) {
                doShow = false;
            }

            if (interestCategoryIds.length > 0 && !$(this).data('interestCategoryIds').split(',').some(function (x) { return interestCategoryIds.includes(x); })) {
                doShow = false;
            }

            if (placeIds.length > 0 && !$(this).data('placeIds').split(',').some(function (x) { return placeIds.includes(x); })) {
                doShow = false;
            }

            if (specialSkillIds.length > 0 && !$(this).data('specialSkillIds').split(',').some(function (x) { return specialSkillIds.includes(x); })) {
                doShow = false;
            }

            if (!doShow) {
                $(this).hide();
            }
        });

        var urlParams = [];

        if (interestIds.length > 0) {
            var interestParams = { idName: 'interestIds', idArray: interestIds.join() };

            urlParams.push(interestParams);
        };

        if (interestCategoryIds.length > 0) {
            var interestCategoryParams = { idName: 'interestCategoryIds', idArray: interestCategoryIds.join() };

            urlParams.push(interestCategoryParams);
        };

        if (placeIds.length > 0) {
            var placeParams = { idName: 'placeIds', idArray: placeIds.join() };

            urlParams.push(placeParams);
        };

        if (specialSkillIds.length > 0) {
            var specialSkillsParams = { idName: 'specialSkillIds', idArray: specialSkillIds.join() };

            urlParams.push(specialSkillsParams);
        };

        newUrl = newUrl = '?';

        urlParams.forEach(function (x, index) {
            if (index >= 1) {
                newUrl = newUrl + '&';
            }

            newUrl = newUrl + x.idName + '=' + x.idArray;
        })

        history.replaceState({ path: newUrl }, '', newUrl);

        $('.departmentDiv').each(function (i, e) {
            if ($(this).find('.volunteerGroupDiv:visible').length === 0) {
                $(this).hide();
            }
        });
    }
}